import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers, RequestMethod, URLSearchParams } from "@angular/http";
import { Observable } from "rxjs";
import { Subject } from 'rxjs/Subject';
import { Router } from "@angular/router";

@Injectable()
export class FormService {
 
    constructor(private _http : Http, private router : Router) {}

    getTypesLocaux(){
        return [
            {
                lib : 'Magasin',
                value : '3'
            },
            {
                lib : 'Hôtellerie',
                value : '11'
            },
            {
                lib : 'Bâtiment',
                value : '12'
            },
            {
                lib : 'Bureau',
                value : '2'
            },
            {
                lib : 'Atelier',
                value : '4'
            },
            {
                lib : 'Terrain',
                value : '9'
            },
            {
                lib : 'Entrepôt',
                value : '5'
            },
            {
                lib : 'Parking',
                value : '7'
            },
            {
                lib : 'Autres',
                value : '1'
            }
        ]
    }

    getSuperficiesLocaux() {
        return [
            {
                lib : 'De 0 à 100 m²',
                value : '1'
            },
            {
                lib : 'De 100 à 200 m²',
                value : '2'
            },
            {
                lib : 'De 200 à 300 m²',
                value : '3'
            },
            {
                lib : 'De 300 à 600 m²',
                value : '4'
            },
            {
                lib : 'De 600 à 1000 m²',
                value : '5'
            },
            {
                lib : 'De 1000 à 1500 m²',
                value : '6'
            },
            {
                lib : 'De 1500 à 2500 m²',
                value : '7'
            },
            {
                lib : 'De 2500 à 6000 m²',
                value : '8'
            },
            {
                lib : 'Pus de 6000 m²',
                value : '9'
            }
        ]
    }

}



// WEBPACK FOOTER //
// ./src/app/locaux/services/form.service.ts